<template>
  <div class="progressbar-container">
    <div class="progressbar-content" :style="widthStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    steps: Number,
    currentStep: Number
  },
  computed: {
    widthStyle() {
      if (this.currentStep < 5) {
        return 'width: ' + (100 / this.steps) * this.currentStep + '%;';
      }
      return 'width: ' + (98 / this.steps) * this.currentStep + '%;';
    }
  }
};
</script>

<style scoped lang="scss">
.progressbar-container {
  position: relative;
  width: 100%;
  height: 5px;
  min-height: 5px;
  background-color: #ced1d8;

  .progressbar-content {
    height: 100%;
    background-color: #77a9d7;
  }
}
</style>
